import React from 'react';
import ProjectLogo from '../../../../img/logotipo.svg';

//css
import './banner.css';

const Banner = () => {
  return (
    
    <div className='meow__banner section__padding'>
      <div className='meow__banner_content'>
        <div className='meow__banner_text'>
          <h1>Você é empreendedora e está procurando crédito para seu microempreendimento, negócio ou produção rural?</h1>
          <p>Entre em contato conosco para ter acesso a crédito acessível. Preencha o formulário abaixo e comece a revolução do empreendedorismo feminino.</p>
        </div>
        <div className='meow__banner_logo'>
          <img src={ProjectLogo} alt='projectlogo' />
        </div>
      </div>
      <div className="meow__banner__button">
        <a href="https://b2black.com.br/index.php/querocredito/" target="_blank" rel="noopener noreferrer" className="meow__banner__link">
          Aplicar para crédito
        </a>
      </div>
    </div>
  )
}

export default Banner;
